<form #blockInputs="ngForm">
  <glxy-form-field suffixText="px">
    <glxy-label>{{ 'EMAIL_BUILDER.DIVIDER_BLOCK.HEIGHT' | translate }}</glxy-label>
    <input
      matInput
      type="number"
      pattern="[0-9]*"
      inputmode="numeric"
      name="Divider Height"
      placeholder="{{ 'EMAIL_BUILDER.DIVIDER_BLOCK.PLACEHOLDER_DEFAULT' | translate }}"
      [(ngModel)]="content.dividerHeight"
      emailHoldShiftToChangeNumberFieldByTen
    />
  </glxy-form-field>

  <glxy-form-field>
    <glxy-label>{{ 'EMAIL_BUILDER.DIVIDER_BLOCK.COLOR' | translate }}</glxy-label>
    <glxy-hint>{{ 'EMAIL_BUILDER.DIVIDER_BLOCK.COLOR_HINT' | translate }}</glxy-hint>
    <input matInput type="color" name="Divider Color" [(ngModel)]="content.dividerColor" />
    <input
      matInput
      type="text"
      placeholder="{{ 'PLACEHOLDER_OPTIONAL' | translate }}"
      name="Divider Color Hex"
      [(ngModel)]="content.dividerColor"
    />
  </glxy-form-field>
</form>
